import BalanceMovements from '@/screens/balance/List'
import auth from './middleware/auth'

export default [
  {
    path: '/movements',
    component: BalanceMovements,
    name: 'BalanceMovements',
    meta: {
      requireAuth: true,
      permissions: ['manager', 'financier'],
      middleware: { auth }
    }
  }
]
